import moment from 'moment';

export function getDateSeconds(date: Date) {
  const hoursToSeconds = moment(date).get('hours') * 60 * 60;
  const minutesToSeconds = moment(date).get('minutes') * 60;

  return hoursToSeconds + minutesToSeconds;
}
